import { TBusinessPriotityProgramOffering } from '../model/types'

export const BUSINESS_PRIORITY_PROGRAM_OFFERING_OPTIONS: TBusinessPriotityProgramOffering[] = [
  'Personal Systems',
  'Core Print',
  'Large Format',
  'Supplies',
]
